
import type { RouteObject } from "react-router-dom";
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Charters = lazy(() => import('../pages/charters/page'));
const Membership = lazy(() => import('../pages/membership/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Login = lazy(() => import('../pages/login/page'));
const Portal = lazy(() => import('../pages/portal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/charters',
    element: <Charters />,
  },
  {
    path: '/membership',
    element: <Membership />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/portal',
    element: <Portal />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
